import React from "react";
import styles from "./MTabs.module.css";

interface TabOption {
  value: string;
  label: string;
}

interface MTabsProps<T extends string> {
  activeTab: T;
  tabs: TabOption[];
  onTabChange: (tab: T) => void;
}

export const MTabs = <T extends string>({
  activeTab,
  tabs,
  onTabChange,
}: MTabsProps<T>) => {
  return (
    <div className={styles.tabsContainer}>
      {tabs.map((tab, index) => (
        <button
          key={tab.value}
          onClick={() => onTabChange(tab.value as T)}
          className={`${styles.tab} ${
            activeTab === tab.value ? styles.active : ""
          } ${index === 0 ? styles.firstTab : ""} ${
            index === tabs.length - 1 ? styles.lastTab : ""
          }`}
        >
          <span className={styles.tabText}>{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default MTabs;
